import React, { useEffect, useState } from 'react';
import Select from '@mui/material/Select';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';
import { SELECT_BUTTON_CLASS_NAME, SELECT_MENU_CLASS_NAME } from '../../theme/constants/select';

const SelectButton = ({
  children,
  value: propValue,
  onChange,
  buttonRef,
  className,
  ...props
}) => {
  const [value, setValue] = useState(propValue ?? '');

  useEffect(() => {
    setValue(propValue ?? '');
  }, [propValue]);

  const handleChange = (event) => {
    setValue(event.target.value);
    onChange?.(event);
  };

  return (
    <Select
      IconComponent={ExpandMore}
      variant="standard"
      value={value}
      onChange={handleChange}
      ref={buttonRef}
      className={className}
      MenuProps={{
        PaperProps: {
          className: SELECT_MENU_CLASS_NAME,
        },
        MenuListProps: {
          sx: {
            py: 0,
          },
        },
      }}
      {...props}
    >
      {children}
    </Select>
  );
};

SelectButton.propTypes = {
  children: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  buttonRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({}),
  ]),
  className: PropTypes.string,
};

SelectButton.defaultProps = {
  buttonRef: null,
  children: null,
  value: '',
  onChange: () => {},
  className: SELECT_BUTTON_CLASS_NAME,
};

export default SelectButton;
